import { StoreNudgeDialog, useStoreNudge } from '@/features/store-nudge'
import { useReducedMotion } from '@/shared/hooks/useReducedMotion'

/**
 * Ancora o nudge da lojinha no shell, irmão do `RewardGainBadgeHost` e fora
 * da página: troca de rota remonta a página, e a janela de consolidação não
 * pode reiniciar no meio. O estado da máquina vive num store de módulo, então
 * o desmonte em level play (shell trocado pelo `PassthroughShell`) não perde
 * um lote pendente.
 */
export const StoreNudgeHost = () => {
  const { batch, open, dismiss, goToStore } = useStoreNudge()
  const reducedMotion = useReducedMotion()

  return (
    <StoreNudgeDialog
      open={open}
      batch={batch}
      reducedMotion={reducedMotion}
      onDismiss={dismiss}
      onGoToStore={goToStore}
    />
  )
}

StoreNudgeHost.displayName = 'StoreNudgeHost'
